module.exports = __webpack_public_path__ + "img/Amex.06d7c88c.svg";